import { makeStyles } from "tss-react/mui";
import {
  MiBox,
  MiDetailPageHeader,
  MiSectionHeader,
} from "@miplatform/components";
import { mdiChevronLeft } from "@mdi/js";
import { Box } from "@mui/material";
import { LegalCard } from "./components/LegalCard";

export function Legal() {
  const { classes } = useStyles();

  return (
    <Box className={classes.contentContainer}>
      <MiDetailPageHeader title="Legal" titleIcon={mdiChevronLeft} />
      <MiBox className={classes.legalCardContainer}>
        <MiSectionHeader
          title="Legal Documents"
          subtitle="In-depth tutorials and guides to help you use MiView"
        />
        <LegalCard
          title="End User License Agreement (EULA)"
          subtitle="The terms and conditions for using our software and services."
          link={{ href: "https://miviewis.com/eula", title: "Read EULA" }}
        />
        <LegalCard
          title="Privacy Policy"
          subtitle="How we collect, use, and protect your personal information"
          link={{
            href: "https://miviewis.com/privacy-policy",
            title: "Read Privacy Policy",
          }}
        />
      </MiBox>
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "inherit",
  },
  legalCardContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
}));
